import React, { useEffect, useState, useRef } from 'react';
import { useSiteExportStore} from '../../store/useSiteExport';
import { Upload } from 'lucide-react';
import { getRuntimeConfig } from '../../runtime-config';
// import { appInsights } from '../../MSAppInsights/AppInsights';

const config = getRuntimeConfig();

const GlobalButtonInjector = () => {
  const [injected, setInjected] = useState(false);
  const allEntitiesExport = useSiteExportStore((state) => state.entities);
  const clearAllentities = useSiteExportStore((state) => state.clearAllEntities);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  // Export checkboxes
  const [exportFlurstucke, setExportFlurstucke] = useState(true);
  const [exportGebaude, setExportGebaude] = useState(true);
  const [exportTopographie, setExportTopographie] = useState(true);

  // Settings checkboxes
  const [projectFlurstuckeOnTopo, setProjectFlurstuckeOnTopo] = useState(false);
  const [projectBuildingsOnTopo, setProjectBuildingsOnTopo] = useState(true);
  const [projectBuildingsOnFlurstucke, setProjectBuildingsOnFlurstucke] = useState(false);
  const [isExportButtonDisabled, setIsExportButtonDisabled] = useState(false);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      dropdownRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start", // "nearest",
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.revitBauGISAppObject !== 'undefined' && window.myAppObject !== null) {
    
      setInjected(true);
    } else {
      
      setInjected(false);
      
    }
  }, []);

 

  const handleClick = () => {
    const exportConfig = {
      export: {
        flurstucke: exportFlurstucke,
        gebaude: exportGebaude,
        topographie: exportTopographie
      },
      settings: {
        projectFlurstuckeOnTopography: projectFlurstuckeOnTopo,
        projectBuildingsOnTopography: projectBuildingsOnTopo,
        projectBuildingsOnFlurstucke: projectBuildingsOnFlurstucke
      },
       appInsightsPayload:{
        connectionString: config.APPLICATIONINSIGHTS_CONNECTION_STRING,
        account: sessionStorage.getItem('jobrole') || 'None',
      }

    };
    
   
    const combinedData = {
      entities: allEntitiesExport,
      config: exportConfig
      };
    const exportdata = JSON.stringify(combinedData);
    //console.log('export data', exportdata)
    
    if (allEntitiesExport && exportdata) {
      try {
        if (window.revitBridge4Site) {
          // console.log("Sending geometry to Revit:");
          // appInsights.trackEvent({
          //   name: "Export nach Revit",
          //   properties: {
          //     exportFlurstucke,
          //     exportGebaude,
          //     exportTopographie,
          //     entityCount: allEntitiesExport.length
          //   }
          // });
          window.revitBridge4Site.importGeometry(exportdata);
//clearAllentities();
          return true;
        } else {
          console.error("Revit bridge not found"); // add user notification
          return false;
        }
      } catch (error) {
        console.error("Error sending geometry to Revit:", error); // add user notfication
        return false;
      }
    } else {
      console.warn("No geometry available to export");// add user notfication
      return false;
    }
  };

  const handleSingleExportClick = () => {
    if (isExportButtonDisabled) {
      return;
    }

    setIsExportButtonDisabled(true);
    handleClick();

    // Block rapid double-clicks, then allow another export.
    window.setTimeout(() => {
      setIsExportButtonDisabled(false);
    }, 1500);
  };

  return (
  <div>
    {injected && (
      <div>
        <button 
          onClick={() => setIsOpen(!isOpen)}
          style={{
            fontWeight: "600",
            backgroundColor: "rgb(255, 255, 255)",
            color: "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontFamily: "GoldbeckNextSemiBold2",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
            fontSize: "15px",
            left: "85px",
            marginLeft:'40px'
          }}
        >
          
          Export zu Revit  {isOpen ? '▲' : '▼'}
        </button>

        {isOpen && (
  <div ref={dropdownRef}
  >
    <div>
      {/* WHAT TO EXPORT Section */}
      <h4 style={{
        margin: 0,
        fontSize: '0.875rem',
        fontWeight: '600',
        letterSpacing: '0.05em',
        fontFamily: "GoldbeckNextSemiBold2",
        color: '#374151',
        marginLeft:'-9px'
      }}>Was soll exportiert werden?</h4>
      
      <div style={{
          marginLeft: '-10px' // ADJUST: Move checkboxes left
        }}>
        <label 
        style={{
          margin: 0,
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151'
         
        }}>
          <input 
            type="checkbox" 
            checked={exportFlurstucke} 
            onChange={(e) => setExportFlurstucke(e.target.checked)} 
               style={{
                  appearance: 'none',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  border: '2px solid #6B7280',
                  cursor: 'pointer',
                  position: 'relative',
                  backgroundColor: 'white',
                  backgroundImage: exportFlurstucke 
                    ? 'radial-gradient(circle, #6B7280 50%, white 50%)'
                    : 'none',
                  flexShrink: 0,
                  marginRight: '6px',
                  verticalAlign:'middle'
                }}
          />
          Flurstücke
        </label>
      </div>
      <div  style={{
          marginLeft: '-10px' // ADJUST: Move checkboxes left
        }}>
        <label style={{
          margin: 0,
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151'
        }}>
          <input 
            type="checkbox" 
            checked={exportGebaude} 
            onChange={(e) => {
              setExportGebaude(e.target.checked)
              const checked = e.target.checked
              console.log(checked)
              if(!checked)
              {
                setProjectBuildingsOnTopo(false);
                setProjectBuildingsOnFlurstucke(false);

              }
              if(checked)
              {
                setProjectBuildingsOnTopo(true);
              }
             
            } } 
               style={{
                  appearance: 'none',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  border: '2px solid #6B7280',
                  cursor: 'pointer',
                  position: 'relative',
                  backgroundColor: 'white',
                  backgroundImage: exportGebaude 
                    ? 'radial-gradient(circle, #6B7280 50%, white 50%)'
                    : 'none',
                  flexShrink: 0,
                  marginRight: '6px',
                  verticalAlign:'middle'
                }}
          />
          Gebäude
        </label>
      </div>
      <div  style={{
          marginLeft: '-10px' // ADJUST: Move checkboxes left
        }}>
        <label style={{
          margin: 0,
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151'
        }}>
          <input 
            type="checkbox" 
            checked={exportTopographie} 
            onChange={(e) => setExportTopographie(e.target.checked)} 
               style={{
                  appearance: 'none',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  border: '2px solid #6B7280',
                  cursor: 'pointer',
                  position: 'relative',
                  backgroundColor: 'white',
                  backgroundImage: exportTopographie 
                    ? 'radial-gradient(circle, #6B7280 50%, white 50%)'
                    : 'none',
                  flexShrink: 0,
                  marginRight: '6px',
                  verticalAlign:'middle'
                }}
          />
          Topographie
        </label>
      </div>
    </div>

    <div style={{
      marginTop: '20px' // ADJUST: Spacing between sections
    }}>
      {/* PROJECTION OPTIONS Section */}
      <h4 style={{
        margin: 0,
        fontSize: '0.875rem',
        fontWeight: '600',
        fontFamily: "GoldbeckNextSemiBold2",
        letterSpacing: '0.05em',
        color: '#374151',
        marginLeft:'-9px'
      }}>Projektionsoptionen</h4>
      
      <div>
        <label
        style={{
          marginRight: '0.75rem',
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151',
          marginLeft:'-10px'
        }}>
          <input 
            type="checkbox" 
            checked={projectFlurstuckeOnTopo} 
            onChange={(e) => {
              setProjectFlurstuckeOnTopo(e.target.checked)
              const checked= e.target.checked;
              if(checked){
                setExportFlurstucke(true)
                setExportTopographie(true)
              }
             }
            } 
           style={{
                  appearance: 'none',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  border: '2px solid #6B7280',
                  cursor: 'pointer',
                  position: 'relative',
                  backgroundColor: 'white',
                  backgroundImage: projectFlurstuckeOnTopo 
                    ? 'radial-gradient(circle, #6B7280 50%, white 50%)'
                    : 'none',
                  flexShrink: 0,
                  marginRight: '6px',
                  verticalAlign:'middle'
                }}
          />
          Flurstücke auf Topografie projizieren
        </label>
      </div>
      <div>
        <label style={{
          margin: 0,
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151',
          marginLeft:'-10px'
        }}>
          <input 
            type="radio" 
            name="buildingProjection"
            checked={projectBuildingsOnTopo} 
            onChange={(e) => {
              setProjectBuildingsOnTopo(true);
              setProjectBuildingsOnFlurstucke(false);
              const checked = e.target.checked;
              if(checked)
              {
                setExportGebaude(true)
                setExportTopographie(true)
              }

            }} 
          />
         Gebäude auf Topografie projizieren
        </label>
      </div>
      <div>
        <label style={{
          margin: 0,
          fontSize: '0.82rem',
          fontWeight: '600',
          fontFamily:"GoldbeckNextRegular",
          letterSpacing: '0.05em',
          color: '#374151',
          marginLeft:'-10px'
        }}>
         <input 
        type="radio" 
        name="buildingProjection"
        checked={projectBuildingsOnFlurstucke} 
        onChange={(e) => {
          setProjectBuildingsOnFlurstucke(true);
          setProjectBuildingsOnTopo(false);
          const checked = e.target.checked;
          if(checked)
            {
              setExportGebaude(true)
              setExportFlurstucke(true)
            }
        }} 
      />
          Gebäude auf Flurstücke projizieren
        </label>
      </div>
    </div>

    {/* EXPORT BUTTON - Center Aligned */}
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: '10px',
      marginLeft:'-100px'// ADJUST: Spacing above button
    }}>
      <button 
        onClick={handleSingleExportClick}
        disabled={isExportButtonDisabled}
         style={{
            fontWeight: "600",
            backgroundColor: "rgb(255, 255, 255)",
            color: "black",
            border: "none",
            borderRadius: "4px",
            cursor: isExportButtonDisabled ? "not-allowed" : "pointer",
            opacity: isExportButtonDisabled ? 0.6 : 1,
            fontFamily: "GoldbeckNextSemiBold2",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
            fontSize: "15px",
            left: "85px"
          }}
      >
        <Upload size={18} />
        Export nach Revit
      </button>
    </div>
  </div>
)}
      </div>
    )}
  </div>
);

 
};

export default GlobalButtonInjector;